import type { JSX } from 'preact';
import { formatPhone } from '../../utility';

const NON_NUMERIC_CHARS = /[^0-9]/g;

export type DataAttributes = {
  output?: 'e164';
};

export const Events = {
  beforeinput: handleBeforeInput,
  input: handleInput,
};

export function getDataAttributes({ output = 'e164' }: DataAttributes) {
  return {
    'data-output': output,
    placeholder: '(000) 000-0000',
  };
}

function handleBeforeInput(e: JSX.TargetedEvent<HTMLInputElement, InputEvent>) {
  const { currentTarget } = e;
  const { selectionStart } = currentTarget;

  if (selectionStart >= 5 && selectionStart <= 6) {
    // set cursor at last digit of area code
    currentTarget.setSelectionRange(4, 4);
  } else if (selectionStart === 10) {
    // set cursor at last digit of prefix
    currentTarget.setSelectionRange(9, 9);
  }
}

function handleInput(e: JSX.TargetedEvent<HTMLInputElement, InputEvent>) {
  const { currentTarget } = e;
  const { nextElementSibling, value } = currentTarget;
  const hiddenField = nextElementSibling as HTMLInputElement;
  const cleanedValue = value.replace(NON_NUMERIC_CHARS, '') || '';

  if (!cleanedValue) {
    currentTarget.value = '';
    hiddenField.value = '';
  } else {
    const formatted = formatPhone(cleanedValue);
    currentTarget.value = formatted;
    hiddenField.value = formatPhone(formatted, 'E.164');
  }
}
